// extracted by mini-css-extract-plugin
module.exports = {"text":"FieldOverviewListSection_text__3TW-L","checkbox":"FieldOverviewListSection_checkbox__3jT3L"};